import React, { useState } from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { WhatsAppButton } from '../../components/feature/WhatsAppButton';
import { Button } from '../../components/base/Button';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // İlan verme formu state
  const [listingFormData, setListingFormData] = useState({
    name: '',
    email: '',
    phone: '',
    facility: '',
    location: '',
    weekCount: '',
    description: '',
  });
  const [isListingSubmitting, setIsListingSubmitting] = useState(false);
  const [listingSubmitSuccess, setListingSubmitSuccess] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleListingInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setListingFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new URLSearchParams();
      
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d68s2evmvg9ih2c79nlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setTimeout(() => setSubmitSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleListingSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsListingSubmitting(true);

    try {
      const formDataToSend = new URLSearchParams();
      
      Object.entries(listingFormData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d68s4llbd17lru29l080', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString(),
      });

      if (response.ok) {
        setListingSubmitSuccess(true);
        setListingFormData({ name: '', email: '', phone: '', facility: '', location: '', weekCount: '', description: '' });
        setTimeout(() => setListingSubmitSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Listing form submission error:', error);
    } finally {
      setIsListingSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#0A1628] to-[#1a2d4d]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            İletişim
          </h1>
          <p className="text-xl text-white/80 max-w-3xl">
            Sorularınız için bize ulaşın, size yardımcı olmaktan mutluluk duyarız
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="text-3xl font-bold text-[#0A1628] mb-8">
                İletişim Bilgileri
              </h2>

              <div className="space-y-6 mb-12">
                {[
                  {
                    icon: 'ri-phone-line',
                    title: 'Telefon',
                    content: '+90 544 395 39 35',
                    link: 'tel:+905443953935',
                  },
                  {
                    icon: 'ri-whatsapp-line',
                    title: 'WhatsApp',
                    content: '+90 544 395 39 35',
                    link: 'https://wa.me/905443953935',
                  },
                  {
                    icon: 'ri-mail-line',
                    title: 'E-posta',
                    content: 'info.sapphire.gayrimenkul@gmail.com',
                    link: 'mailto:info.sapphire.gayrimenkul@gmail.com',
                  },
                  {
                    icon: 'ri-map-pin-line',
                    title: 'Adres',
                    content: 'Atatürk Bulvarı No:123, Antalya, Türkiye',
                    link: null,
                  },
                ].map((info, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl flex-shrink-0">
                      <i className={`${info.icon} text-2xl text-[#D4AF37]`}></i>
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-[#0A1628] mb-1">
                        {info.title}
                      </h3>
                      {info.link ? (
                        <a
                          href={info.link}
                          target={info.link.startsWith('http') ? '_blank' : undefined}
                          rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="text-lg text-[#6B7A90] hover:text-[#D4AF37] transition-colors"
                        >
                          {info.content}
                        </a>
                      ) : (
                        <p className="text-lg text-[#6B7A90]">{info.content}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-[#F7F9FC] rounded-2xl p-8">
                <h3 className="text-xl font-bold text-[#0A1628] mb-4">
                  Çalışma Saatleri
                </h3>
                <div className="space-y-3 text-base text-[#6B7A90]">
                  <div className="flex justify-between">
                    <span>Pazartesi - Cuma</span>
                    <span className="font-semibold text-[#0A1628]">09:00 - 18:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Cumartesi</span>
                    <span className="font-semibold text-[#0A1628]">10:00 - 16:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Pazar</span>
                    <span className="font-semibold text-[#0A1628]">Kapalı</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-[#0A1628] mb-8">
                Bize Yazın
              </h2>

              {submitSuccess && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-center gap-3">
                  <i className="ri-check-circle-line text-2xl text-green-600"></i>
                  <p className="text-base text-green-800">
                    Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                  </p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="general-contact-form">
                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    Adınız Soyadınız <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Adınız ve soyadınız"
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      E-posta <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="ornek@email.com"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      Telefon <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      placeholder="+90 5XX XXX XX XX"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    Konu <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors cursor-pointer"
                  >
                    <option value="">Konu seçiniz</option>
                    <option value="İlan Hakkında">İlan Hakkında</option>
                    <option value="Satış Süreci">Satış Süreci</option>
                    <option value="Teknik Destek">Teknik Destek</option>
                    <option value="Genel Bilgi">Genel Bilgi</option>
                    <option value="Diğer">Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    Mesajınız <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={6}
                    maxLength={500}
                    placeholder="Mesajınızı buraya yazın... (max 500 karakter)"
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors resize-none"
                  />
                  <p className="text-sm text-[#6B7A90] mt-2">
                    {formData.message.length} / 500 karakter
                  </p>
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  disabled={isSubmitting}
                  className="w-full"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line mr-2 animate-spin"></i>
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      Mesaj Gönder
                    </>
                  )}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* İlan Vermek İstiyorum Section */}
      <section className="py-16 bg-gradient-to-br from-[#0A1628] to-[#1a2d4d]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Left Side - Info */}
            <div>
              <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 px-4 py-2 rounded-full mb-6">
                <i className="ri-megaphone-line text-[#D4AF37]"></i>
                <span className="text-sm font-semibold text-[#D4AF37]">İlan Başvurusu</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                İlan Vermek İstiyorum
              </h2>
              
              <p className="text-lg text-white/80 mb-8">
                Devremülkünüzü satmak mı istiyorsunuz? Formu doldurun, uzman ekibimiz sizinle iletişime geçsin. 
                İlanınızı profesyonel fotoğraflar ve detaylı açıklamalarla hazırlayalım.
              </p>

              <div className="space-y-4 mb-8">
                {[
                  { icon: 'ri-camera-line', text: 'Profesyonel fotoğraf çekimi' },
                  { icon: 'ri-file-text-line', text: 'Detaylı ilan açıklaması' },
                  { icon: 'ri-shield-check-line', text: 'Güvenilir alıcı havuzu' },
                  { icon: 'ri-customer-service-2-line', text: 'Satış sürecinde tam destek' },
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/20 rounded-lg">
                      <i className={`${item.icon} text-xl text-[#D4AF37]`}></i>
                    </div>
                    <span className="text-white/90">{item.text}</span>
                  </div>
                ))}
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ri-information-line text-2xl text-[#D4AF37]"></i>
                  <h3 className="text-lg font-semibold text-white">Nasıl Çalışır?</h3>
                </div>
                <ol className="space-y-2 text-white/80 text-sm">
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-[#D4AF37]">1.</span>
                    Formu doldurun ve başvurunuzu gönderin
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-[#D4AF37]">2.</span>
                    Ekibimiz 24 saat içinde sizinle iletişime geçer
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-[#D4AF37]">3.</span>
                    İlanınızı birlikte hazırlar ve yayına alırız
                  </li>
                </ol>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-[#0A1628] mb-6">
                İlan Başvuru Formu
              </h3>

              {listingSubmitSuccess && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-center gap-3">
                  <i className="ri-check-circle-line text-2xl text-green-600"></i>
                  <div>
                    <p className="text-base font-semibold text-green-800">
                      Başvurunuz alındı!
                    </p>
                    <p className="text-sm text-green-700">
                      En kısa sürede sizinle iletişime geçeceğiz.
                    </p>
                  </div>
                </div>
              )}

              <form onSubmit={handleListingSubmit} className="space-y-5" data-readdy-form id="listing-application-form">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      Adınız Soyadınız <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={listingFormData.name}
                      onChange={handleListingInputChange}
                      required
                      placeholder="Adınız ve soyadınız"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      Telefon <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={listingFormData.phone}
                      onChange={handleListingInputChange}
                      required
                      placeholder="+90 5XX XXX XX XX"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    E-posta <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={listingFormData.email}
                    onChange={handleListingInputChange}
                    required
                    placeholder="ornek@email.com"
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      Tesis Adı <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="facility"
                      value={listingFormData.facility}
                      onChange={handleListingInputChange}
                      required
                      placeholder="Örn: Limak Limra"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                      Lokasyon <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="location"
                      value={listingFormData.location}
                      onChange={handleListingInputChange}
                      required
                      placeholder="Örn: Antalya, Kemer"
                      className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    Hafta Sayısı <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="weekCount"
                    value={listingFormData.weekCount}
                    onChange={handleListingInputChange}
                    required
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors cursor-pointer"
                  >
                    <option value="">Hafta sayısı seçiniz</option>
                    <option value="1 Hafta">1 Hafta</option>
                    <option value="2 Hafta">2 Hafta</option>
                    <option value="3 Hafta">3 Hafta</option>
                    <option value="4 Hafta">4 Hafta</option>
                    <option value="4+ Hafta">4+ Hafta</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-[#0A1628] mb-2">
                    Ek Bilgiler
                  </label>
                  <textarea
                    name="description"
                    value={listingFormData.description}
                    onChange={handleListingInputChange}
                    rows={4}
                    maxLength={500}
                    placeholder="Devremülkünüz hakkında eklemek istediğiniz bilgiler (dönem, oda tipi, kapasite vb.)"
                    className="w-full px-4 py-3 text-base text-[#0A1628] bg-[#F7F9FC] rounded-xl border-2 border-transparent focus:border-[#D4AF37] focus:outline-none transition-colors resize-none"
                  />
                  <p className="text-sm text-[#6B7A90] mt-2">
                    {listingFormData.description.length} / 500 karakter
                  </p>
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  disabled={isListingSubmitting}
                  className="w-full"
                >
                  {isListingSubmitting ? (
                    <>
                      <i className="ri-loader-4-line mr-2 animate-spin"></i>
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line mr-2"></i>
                      Başvuru Gönder
                    </>
                  )}
                </Button>

                <p className="text-xs text-[#6B7A90] text-center">
                  Başvurunuzu göndererek <a href="/kvkk" className="text-[#D4AF37] hover:underline">KVKK</a> ve{' '}
                  <a href="/gizlilik" className="text-[#D4AF37] hover:underline">Gizlilik Politikası</a>'nı kabul etmiş olursunuz.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-[#F7F9FC]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-3xl font-bold text-[#0A1628] mb-8 text-center">
            Konum
          </h2>
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d192698.38093869!2d28.872955!3d41.005498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7040068086b%3A0xe1ccfe98bc01b0d0!2zxLBzdGFuYnVs!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ofis Konumu"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ContactPage;